import { Component, Input } from "@angular/core";

@Component({
    selector: "app-clare-alert",
    templateUrl: "./clare-alert.component.html",
    styles: [
        `
            .container {
                display: flex; /* Use flex layout to align items horizontally */
                align-items: center; /* Center items vertically */
            }

            .icon {
                margin-right: 10px; /* Add space between icon and message */
                font-size: 20px; /* Adjust the icon size */
            }

            .message {
                margin: 0; /* Reset margin to prevent spacing issues */
                padding: 0; /* Reset padding to prevent spacing issues */
            }

            .alert {
                padding: 20px;
                margin-bottom: 15px;
                text-align: center;
                border-radius: 0.6rem;
            }

            .alert * {
                vertical-align: middle;
            }

            .text-left {
                text-align: left;
            }
        `,
    ],
})
export class ClareAlertComponent {
    @Input() message: string;
    @Input() messageType: "error" | "warning";
    @Input() containerClass = "";

    get hasHtmlTag(): boolean {
        // Check if the message contains any HTML tag
        return /<[^>]*>/i.test(this.message);
    }
}
